import { createActions } from 'redux-actions';

export const followUpModalActions = createActions(
  'FOLLOW_UP_MODAL_OPEN',
  'FOLLOW_UP_MODAL_CLOSE',
);
